export function sendSelected (companyList,param) {
    let selected
    companyList.forEach(element => {
        if(element.id===param)
        {
            selected=element;
        }
    });
    return selected
 }